'use client';

import HelpCircleSvg from '@/assets/svgs/help-circle.svg';

import { Modals } from '@/containers/Modals/all-modals';
import classNames from 'classnames';
import { useRef } from 'react';
import ModalBody from '../ModalBody';
import ModalHeader from '../ModalHeader';
import { ModalProps, QuestionModalParams } from '../types';
import useModals from '../useModals';

import ModalContainer from '../ModalContainer';
import QuestionForm from './QuestionForm';

const modalName = Modals.QuestionModal;

interface QuestionModalProps extends ModalProps {
  className?: string;
  params?: QuestionModalParams;
}

const QuestionModal = ({ className, variant = 'narrow', params }: QuestionModalProps) => {
  const modalBodyRef = useRef<HTMLDivElement>(null);
  const { isModalOpen, onClose } = useModals({
    modalName,
  });

  // Extract jobId and questionId from modal params
  const jobId = params?.jobId || '';
  const questionId = params?.questionId;

  const isEditing = !!questionId;

  return (
    <div className={classNames('relative', className)}>
      <input
        type="checkbox"
        id={modalName}
        className="modal-toggle"
        checked={isModalOpen}
        onChange={() => {}}
      />

      <ModalContainer
        isModalOpen={isModalOpen}
        modalName={modalName}
        variant={variant}
        onClose={onClose}>
        <div className="flex h-full flex-col">
          {/* Stick to top */}
          <ModalHeader
            modalName={modalName}
            icon={<HelpCircleSvg className="h-5 w-5 text-gray-600" />}
            title={isEditing ? 'Edit Question' : 'Add a Question'}
          />

          {/* Take up remaining space and enable inside-scrolling */}
          <ModalBody ref={modalBodyRef} className="px-5 !py-0">
            {/* Spacing for consistency */}
            <div className="h-6" />
            <QuestionForm postSubmit={onClose} jobId={jobId} questionId={questionId} />
          </ModalBody>
        </div>
      </ModalContainer>
    </div>
  );
};

export default QuestionModal;
